export const SCROLLBAR_WIDTH = 15;
export const ITEM_HEIGHT = 25;
export const WIDTH_TO_SHOW_DOUBLE_HEIGHT = 600;

export const querySmallScreen = `(max-width: ${WIDTH_TO_SHOW_DOUBLE_HEIGHT}px)`;
export const queryVerySmallScreen = `(max-width: 400px)`;
